/**
 * sophior-kennisbank-hub.js
 * Categorie-pills op /pages/kennisbank springen naar de bijbehorende rij, en
 * oude deeplinks met een categorie-hash (/pages/kennisbank#pannen, van vóór de
 * hub-herbouw van 24 aug 2026) landen op diezelfde rij. Voorheen deed de
 * blog-listing daar een doorverwijzing; met de rijen op de hub zelf is
 * scrollen het juiste gedrag: de bezoeker ziet de categorie mét de doorklik.
 *
 * De browser doet de hash-sprong zelf al — dit script vult twee gaten: de
 * native sprong gebeurt vóór het laden van de afbeeldingen (waardoor de
 * doelrij ernaast komt te staan) en een hash die pas ná het laden verandert.
 */
(function () {
  /* Init-guard: het script staat binnen de sectie, dus de Theme Editor voert
     het bij elke sectie-herrender opnieuw uit. Zonder guard stapelen de
     document-listeners op en doet één pill-klik meerdere pushState-aanroepen. */
  if (window.__sophiorHubInit) return;
  window.__sophiorHubInit = true;

  var ROOT_SELECTOR = '[data-sophior-kennisbank-hub]';

  function scrollNaarRij(handle, smooth) {
    if (!handle || !/^[a-z0-9-]+$/.test(handle)) return false;
    var hub = document.querySelector(ROOT_SELECTOR);
    if (!hub) return false;
    var rij = hub.querySelector('.sophior-kennisbank-hub__row[id="' + handle + '"]');
    if (!rij) return false;
    rij.scrollIntoView({
      block: 'start',
      behavior: smooth && window.matchMedia('(prefers-reduced-motion: no-preference)').matches ? 'smooth' : 'auto'
    });
    return true;
  }

  function scrollNaarHash(smooth) {
    scrollNaarRij(window.location.hash.replace('#', ''), smooth);
  }

  function init() {
    /* Na load: de native hash-sprong gebeurt vóór de lazy afbeeldingen,
       waardoor de doelrij vaak naast beeld staat. Eén correctie is genoeg. */
    scrollNaarHash(false);
    window.addEventListener('hashchange', function () {
      scrollNaarHash(true);
    });

    /* Categorie-pills: vloeiend springen i.p.v. de harde native sprong.
       De hash gaat via pushState mee de adresbalk in, zodat de positie
       deelbaar blijft en de terugknop werkt. Nieuwe-tab-kliks en een
       ontbrekende doelrij vallen terug op het normale linkgedrag. */
    document.addEventListener('click', function (event) {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!(event.target instanceof Element)) return;
      var pill = event.target.closest('.sophior-kennisbank-hub__pill[data-hub-jump]');
      if (!pill) return;
      if (!scrollNaarRij(pill.dataset.hubJump, true)) return;
      event.preventDefault();
      if (window.history && window.history.pushState) {
        window.history.pushState(null, '', '#' + pill.dataset.hubJump);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
